import React from "react";
import Translations from "../../services/translation.service";
import Helpers from "../../helpers/shared.helper";
import EligibilityService from "../../services/eligibility.service";
import EligibilitySuccess from "./eligibility_success.component";
import EligibilityFailed from "./eligibility_failed.component";
import EligibityForm from "./eligibity-form.component";

import Flow from "../../services/flow.service"
import Storage from "../../services/storage.service"
import Numbers from "../../services/numbers.service"
import * as variables from '../../variables';
import EligibilityFailedFinal from "./eligibility_failed_final.component";
import EligibilityFailedPhone from "./eligibility_failed_phone.component";
import EligibilitySuccessOTP from "./eligibility_success_otp.component";
import Settings from "../../services/settings.service";
import Phones from "google-libphonenumber";
import Countries from "../../services/countries.service";
import FirebaseAnalytics from "../../services/analytics.service";
// import GTMService from "../../services/gtm.service";
import User from "../../services/user.service";
import storefront from "../../services/storefront.service";
import EligibilityFailedPostpaid from "./eligibility_failed_postpaid.component";

export default class Eligibility extends React.Component {
  subscriptions = [];

  prefix = "scr_3.3.1_Check_Eligibility_";

  constructor(props) {
    super(props);
    this.state = {
      eligibilityStep: "EligibityForm",
      selectedIdType: null,
      id_number: "",
      selectedNationalityId: null,
      selectedCityId: null,
      idType: null,
      availableNationalities: null,
      availableSaudiCities: null,
      formValid: false,
      iDValid: false,
      iDTouched: false,
      loading: false,
      fetchingNationality: false,
      fetchedNationalityFirstTime: false,
      btnLabel: "",
      basic_data_loaded: false,
      selectedFromIDType: false,
      showPhone: false,
      countryDisabled: true,
      phoneCode: {
        value: "SA",
        iso: 966,
        valid: true,
        touched: false,
      },
      phone: {
        value: "",
        validations: {
          required: true,
          contactNumber: true
        },
        valid: false,
        touched: false,
        dependency: "selected_country_contact",
        error: ""
      },
      actionLoading: false,
      is_post_paid: false,
      // phone: null
    };
  }
  phoneUtil = Phones.PhoneNumberUtil.getInstance();
  idTypeObj = null;
  availableSaudiCitiesObj = null;
  nationalitiesObj = null;


  skipEligibility = () => {
    this.setState({
      loading: true
    })
    Storage.set("eligibility_fulfilled", true, true)
    Flow.next()
  }
  requestMNPAgain = () => {
    this.setState({
      loading: true
    })
    Numbers.portInMyNumber()
  }
  componentDidMount() {
    this.subscriptions.push(
      Translations.getKeysObsrv().subscribe(data => {
        this.setState({
          selectedIdTypeText: Translations.keys[this.prefix + "id_type"],
          selectedNationalityText:
            Translations.keys[this.prefix + "nationality"],
          selectedNationalityDefaultText:
            Translations.keys[this.prefix + "nationality"],
          selectedCityText: Translations.keys[this.prefix + "cities"]
        });
        this.forceUpdate();
        this.populateIdTypeAndCities();
      })
    );

    this.populateIdTypeAndCities();
  }

  populateIdTypeAndCities = () => {
    if (!this.state.selectedIdType) {
      EligibilityService.idType()
        .then(response => {
          if(response?.data){
            let business = Storage.get("business", true);
            let eligibility_id_types = null;
            if (business) {
              business = JSON.parse(business);
              eligibility_id_types = business?.eligibility_id_type
            }
            let apiResponse = response.data;
            const filteredResponse = apiResponse.filter(item => eligibility_id_types.includes(item.Id));
            this.idTypeObj = Helpers.arrayToKeyedObject(filteredResponse, "Id");
            this.setState({ idType: filteredResponse });
            this.updateIdType(filteredResponse[0]?.Id);
          }
        })
        .catch(error => {
          // console.log("error", error);
        });

      EligibilityService.availableSaudiCities()
        .then(response => {
          this.availableSaudiCitiesObj = Helpers.arrayToKeyedObject(
            response.data,
            "Id"
          );
          this.setState({ availableSaudiCities: response.data });
        })
        .catch(error => {
          // console.log("error", error);
        });
    }
  };

  toggleLoading = loading => {
    this.setState({
      loading: loading
    });
  };

  toggleActionLoading = actionLoading => {
    this.setState({
      actionLoading: actionLoading
    });
  };


  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selectedIdType &&
      this.state.selectedIdType !== prevState.selectedIdType
    ) {
      if (this.state.fetchedNationalityFirstTime) {
        this.setState({
          fetchingNationality: true
        });
      } else {
        this.setState({
          fetchingNationality: true,
          fetchedNationalityFirstTime: true
        });
      }

      EligibilityService.availableNationalities(this.state.selectedIdType)
        .then(response => {
          this.nationalitiesObj = Helpers.arrayToKeyedObject(
            response.data,
            "Id"
          );
          if (this.state.selectedIdType === variables.SAUDI_ID) {
            this.setState({
              availableNationalities: response.data,
              selectedNationalityId: response.data[0].Id,
              selectedNationalityText: response.data[0].Nationality,
              selectedFromIDType: true,
              formValid: false,
              fetchingNationality: false
            });
          } else {
            this.setState({
              availableNationalities: response.data,
              selectedNationalityId: null,
              selectedNationalityText: this.state.selectedNationalityDefaultText,
              formValid: false,
              fetchingNationality: false,
              selectedFromIDType: false
            });
          }
        })
        .catch(error => {
          this.setState({
            fetchingNationality: false
          });
          // console.log("error=", error);
        });
    }

    if (
      this.state.idType &&
      this.state.availableSaudiCities &&
      !this.state.basic_data_loaded
    ) {
      this.setState({
        basic_data_loaded: true
      });
    }

    if (
      this.state.id_number.length &&
      this.state.selectedIdType &&
      this.state.selectedNationalityId &&
      this.state.selectedCityId &&
      this.state.phone.valid &&
      !this.state.formValid

    ) {
      this.setState({
        formValid: true
      });
    }
  }

  updateStep = step => {
    this.setState({
      eligibilityStep: step
    });
  };

  updateIdType = event => {
    storefront.tabHorizontalScroll("eligibility_", event);
    let country_selection_type_elligibility = JSON.parse(Storage.get("business", true))["country_selection_type_elligibility"];
    if (event === "0") {
      this.setState({
        selectedIdType: null,
        selectedIdTypeText: Translations.keys[this.prefix + "id_type"],
        selectedNationalityId: null,
        formValid: false,
        showPhone: false
      });
    } else {
      if (event !== this.state.selectedIdType) {
        let type = this.idTypeObj[event].Type;
        this.setState({
          selectedIdType: event,
          selectedIdTypeText: type,
          selectedNationalityId: null,
          formValid: false
        });
      }
      this.setCountryField(event, country_selection_type_elligibility);
    }
  };

  setCountryField = (type, list) => {
    const typeDetail = list.filter((item) => {
      return type === item.Id;
    })
    const typeDetailCC = typeDetail[0].CC.toUpperCase();
    const typeDetailiso = typeDetail[0].iso;
    if(typeDetailCC === "") {
      this.setState({
        phone: {
          value: "",
          data_submition: true,
          valid: false,
          touched: false,
          error: ""
        },
        phoneCode: {
          value: "SA",
          iso: 966,
          valid: true,
          touched: false,
        },
        formValid: false,
        showPhone: true,
        countryDisabled: false,
      });
    } else {
      this.setState({
        phone: {
          value: "",
          data_submition: true,
          valid: false,
          touched: false,
          error: ""
        },
        phoneCode: {
          value: typeDetailCC,
          iso: typeDetailiso,
          valid: true,
          touched: false,
        },
        formValid: false,
        showPhone: true,
        countryDisabled: true,
      });
    }
  }

  isValidIDNumber = (nicNumber) => {
    // Check If nicNumber is a TestID
    const testIDs = Helpers.getTestingIDs();
    if (testIDs?.includes(nicNumber)) return true;

    var prefix = "12";
    var outNumber = parseInt(nicNumber);

    if(nicNumber.length === 0) {
      return false;
    }

    // Bypass Eligibility Checking
    const enableIsValidIDNumber = Helpers.checkEnableFlag("enable_eligibility_id_validation");
    if(!enableIsValidIDNumber) return true

    if (nicNumber.length !== 10 || isNaN(outNumber) || prefix.indexOf(nicNumber[0]) < 0) {
        return false;
    }
    var charArray = nicNumber.split('');
    var numArray = new Array(10);
    for (var k = 0; k < charArray.length; k++) {
        numArray[k] = parseInt(charArray[k]);
    }
    var sum = 0;
    for (var i = 0; i < numArray.length - 1; i++) {
        if (i % 2 !== 0) {
            sum += numArray[i];
        } else {
            var oddByTwo = numArray[i] * 2;
            var oddByTwoString = oddByTwo.toString();
            var oddByTwoArray = new Array(oddByTwoString.length);
            var oddByTwoSum = 0;
            for (var j = 0; j < oddByTwoArray.length; j++) {
                oddByTwoArray[j] = parseInt(oddByTwoString[j]);
                oddByTwoSum += oddByTwoArray[j];
            }
            sum += oddByTwoSum;
        }
    }
    var sumString = sum.toString();
    var unit = parseInt(sumString[sumString.length - 1]);
    if ((unit === 0 && numArray[9] === 0) || ((10 - unit) === numArray[9])) {
        return true;
    }
    return false;
}

  updateIdNumber = event => {
    if (this.isValidIDNumber(event.target.value)) {
      this.setState({
        iDValid: true,
        iDTouched: true,
        id_number: event.target.value
      });
    } else {
      this.setState({
        iDValid: false,
        iDTouched: true,
        id_number: event.target.value
      });
    }
  };


  handleCountryCode = (country_select, country_iso) => {
    this.setState({
      phoneCode: {
        value: country_select,
        touched: true,
        iso: country_iso.substring(1)
      },
    });
    if (this.state.phone?.value?.length) {
      let validcontact = "";
      let value = this.state.phone?.value;
      if (value.length > 6 && Settings.formats.phonenumber.test(value)) {
        let country = null;
        let dependency = country_select;
        country = Countries.Countries[dependency];
        if (country && country.ISO_2Code) {
          let number = this.phoneUtil.parse(value, country.ISO_2Code);
          validcontact = this.phoneUtil.isValidNumber(number);
        } else {
          validcontact = Settings.formats.phonenumber.test(value);
        }
      } else {
        validcontact = false;
      }
      let errorMsg = ""
      if (!validcontact) {
        errorMsg = Translations.keys["scr_3.3.3_error_number_invalid"];
      } else {
        errorMsg = ""
      }

      this.setState({
        phone: {
          value: this.state.phone.value,
          valid: validcontact,
          touched: true,
          error: errorMsg
        },
        formValid: false
      });
    }
  }

  updateContactField = (e) => {
    let validcontact = "";
    let value = e.target.value
    if (value.length > 6 && Settings.formats.phonenumber.test(value)) {
      let country = null;
      let dependency = this.state.phoneCode?.value;
      country = Countries.Countries[dependency];

      if (country && country.ISO_2Code) {
        let number = this.phoneUtil.parse(value, country.ISO_2Code);
        validcontact = this.phoneUtil.isValidNumber(number);

      } else {
        validcontact = Settings.formats.phonenumber.test(value);
      }
    } else {
      validcontact = false;
    }
    let errorMsg = ""
    if (!validcontact && !e.target.value) {
      errorMsg = Translations.keys["scr_3.3.3_error_required_message"]
    } else if (!validcontact && e.target.value) {
      errorMsg = Translations.keys["scr_3.3.3_error_number_invalid"]
    } else {
      errorMsg = ""
    }
    this.setState({
      phone: {
        value: e.target.value,
        data_submition: true,
        valid: validcontact,
        touched: true,
        error: errorMsg
      },
      formValid: false
    });
  }

  updateNationality = event => {
    if (event.target.value === "0") {
      this.setState({
        selectedNationalityId: null,
        selectedNationalityText: Translations.keys[this.prefix + "nationality"],
        formValid: false
      });
    } else {
      this.setState({
        selectedNationalityId: event.target.value,
        selectedNationalityText: this.nationalitiesObj[event.target.value]
          .Nationality
      });
    }
  };

  updateCity = event => {
    if (event.target.value === "0") {
      this.setState({
        selectedCityId: null,
        selectedCityText: Translations.keys[this.prefix + "cities"],
        formValid: false
      });
    } else {
      this.setState({
        selectedCityId: event.target.value,
        selectedCityText: this.availableSaudiCitiesObj[event.target.value].City
      });
    }
  };

  checkEligibilityRoot = () => {
    this.toggleLoading(true);
    Storage.set("eligibility_id_type", this.state.selectedIdType, true);
    const contact_number = this.state.phoneCode?.iso + this.state.phone?.value;
    let data = {
      id_type: this.state.selectedIdType,
      id_number: this.state.id_number,
      nationality_id: this.state.selectedNationalityId,
      city_id: this.state.selectedCityId,
      contact_number: contact_number
    };
    let firebase_param = {
      nationality: this.state.selectedNationalityText,
      ID_type: this.state.selectedIdTypeText
    }
    FirebaseAnalytics.create_account_check(firebase_param);
    this.toggleActionLoading(true);

    Storage.set("eligibilityErrorStatus", true, true);
    EligibilityService.checkEligibility(data)
      .then(response => {
        this.toggleLoading(false);
        Storage.clear("eligibilityErrorStatus");
        if (response.data.is_eligible) {
          // let fgplan = JSON.parse(localStorage.getItem("is_broadband_plan_selected"));
          // if (!fgplan) {
          //   GTMService.set_data_for_eligibility_check();
          // }
          // Check if OTP needs to be entered
          if(response?.data?.is_post_paid) {
            this.setState({
              is_post_paid: response?.data?.is_post_paid
            });
          }
          if (response.data.otp_needed) {
            this.updateStep("EligibilitySuccessOTP");
            this.toggleActionLoading(false);
          } else {
            User.updateFlowStatus("IsEligible", true)
              .then(updateFlowStatusResponse => {
                this.updateStep("EligibilitySuccess");
                this.toggleActionLoading(false);
                Storage.set("eligibility_fulfilled", true, true)
              })
              .catch(error => {
                this.toggleActionLoading(false);
              });
          }
        } else {
          if (response.data.code === 7297) {
            // ContactNumberNotValid | TahaqaqValidationFailed
            this.updateStep("EligibilityFailedPhone");
          } else if (response.data.code === 7298) {
            // YouReachedTheMaximumNumberOfRetry
            this.updateStep("EligibilityFailedFinal");
          } else if (response.data.code === 7300) {
            // EligibilityFailedForPostPaid
            this.updateStep("EligibilityFailedPostpaid");
          } else {
            // Rest of the conditions
            this.updateStep("EligibilityFailed");
          }
          this.toggleActionLoading(false);
        }
      })
      .catch(error => {
        if (error.response.data.code === -7297) {
          // ContactNumberNotValid | TahaqaqValidationFailed
          this.updateStep("EligibilityFailedPhone");
        } else if (error.response.data.code === -7298) {
          // YouReachedTheMaximumNumberOfRetry
          this.updateStep("EligibilityFailedFinal");
        } else if (error.response.data.code === -7300) {
          // EligibilityFailedForPostPaid
          this.updateStep("EligibilityFailedPostpaid");
        } else {
          // Rest of the conditions
          this.updateStep("EligibilityFailed");
        }
        this.toggleLoading(false);
        Storage.clear("eligibilityErrorStatus");
      });
  };


  render() {
    let content = null;
    switch (this.state.eligibilityStep) {
      case "EligibityForm":
        content = (
          <EligibityForm
            action={this.updateStep}
            selectedIdType={this.state.selectedIdType}
            selectedIdTypeText={this.state.selectedIdTypeText}
            selectedNationalityId={this.state.selectedNationalityId}
            selectedNationalityText={this.state.selectedNationalityText}
            selectedNationalityDefaultText={
              this.state.selectedNationalityDefaultText
            }
            selectedFromIDType={this.state.selectedFromIDType}
            selectedCityId={this.state.selectedCityId}
            selectedCityText={this.state.selectedCityText}
            iDValid={this.state.iDValid}
            updateIdType={this.updateIdType}
            updateIdNumber={this.updateIdNumber}
            phone={this.state.phone}
            phoneCode={this.state.phoneCode}
            countryDisabled={this.state.countryDisabled}
            updateContactField={this.updateContactField}
            handleCountryCode={this.handleCountryCode}
            id_number={this.state.id_number}
            updateNationality={this.updateNationality}
            updateCity={this.updateCity}
            state={this.state}
            toggleLoading={this.toggleLoading}
            showPhone={this.state.showPhone}
            checkEligibilityRoot={this.checkEligibilityRoot}
          />
        );
        break;
      case "EligibilitySuccess":
        content = <EligibilitySuccess />;
        break;
      case "EligibilitySuccessOTP":
        content = <EligibilitySuccessOTP
          action={this.updateStep}
          id_number={this.state.id_number}
          selectedIdType={this.state.selectedIdType}
          selectedNationalityId={this.state.selectedNationalityId}
          selectedCityId={this.state.selectedCityId}
          phone={this.state.phone}
          phoneCode={this.state.phoneCode}
          checkEligibilityRoot={this.checkEligibilityRoot}
          toggleLoading={this.toggleLoading}
          is_post_paid={this.state.is_post_paid}
          loading={this.state.loading}
        />;
        break;
      case "EligibilityFailedPhone":
        content = <EligibilityFailedPhone
          phone={this.state.phone}
          phoneCode={this.state.phoneCode}
          countryDisabled={this.state.countryDisabled}
          updateContactField={this.updateContactField}
          handleCountryCode={this.handleCountryCode}
          loading={this.state.loading}
          checkEligibilityRoot={this.checkEligibilityRoot}
        />
        break;
      case "EligibilityFailedFinal":
        content = <EligibilityFailedFinal
          loading={this.state.loading}
        />
        break;
      case "EligibilityFailed":
        content = (
          <EligibilityFailed
            selectedIdTypeText={this.state.selectedIdTypeText}
            id_number={this.state.id_number}
            selectedNationalityText={this.state.selectedNationalityText}
            selectedCityText={this.state.selectedCityText}
            re_enter_data={this.updateStep}
            skipEligibility={this.skipEligibility}
            requestMNPAgain={this.requestMNPAgain}
            loading={this.state.loading}
          />
        );
        break;
      case "EligibilityFailedPostpaid":
        content = <EligibilityFailedPostpaid
          loading={this.state.loading}
          toggleLoading={this.toggleLoading}
        />
        break;
      default:
        content = (
          <EligibityForm
            action={this.updateStep}
            selectedIdType={this.state.selectedIdType}
            selectedIdTypeText={this.state.selectedIdTypeText}
            selectedNationalityId={this.state.selectedNationalityId}
            selectedNationalityText={this.state.selectedNationalityText}
            selectedNationalityDefaultText={
              this.state.selectedNationalityDefaultText
            }
            selectedFromIDType={this.state.selectedFromIDType}
            selectedCityId={this.state.selectedCityId}
            selectedCityText={this.state.selectedCityText}
            iDValid={this.state.iDValid}
            updateIdType={this.updateIdType}
            updateIdNumber={this.updateIdNumber}
            phone={this.state.phone}
            phoneCode={this.state.phoneCode}
            countryDisabled={this.state.countryDisabled}
            updateContactField={this.updateContactField}
            handleCountryCode={this.handleCountryCode}
            id_number={this.state.id_number}
            updateNationality={this.updateNationality}
            updateCity={this.updateCity}
            state={this.state}
            toggleLoading={this.toggleLoading}
            showPhone={this.state.showPhone}
            checkEligibilityRoot={this.checkEligibilityRoot}
          />
        );
    }
    return content;
  }
}
